import Polyglot from 'node-polyglot'

const translations = {
    en: {
        'no.results.for': 'No results found for:'
    },
    es: {
        'no.results.for': 'No se encontraron resultados para:'
    },
    fr: {
        'no.results.for': 'Aucun résultat trouvé pour:'
    }
}
const locale = document.documentElement.lang && document.documentElement.lang.toLowerCase();
const shortLocale = locale.substr(0,2);
const availableLocale = translations[locale] ? locale : translations[shortLocale] ? shortLocale : 'es'

const polyglot = new Polyglot({
    locale: availableLocale
})

polyglot.extend(translations[polyglot.locale()])

const t = polyglot.t.bind(polyglot)

export { t as default, polyglot }
